import { render } from "./GridTable.vue?vue&type=template&id=04c70650&scoped=true"
import script from "./GridTable.vue?vue&type=script&lang=js"
export * from "./GridTable.vue?vue&type=script&lang=js"

import "./GridTable.vue?vue&type=style&index=0&id=04c70650&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c70650"]])

export default __exports__